import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * nova-graph's useRetained, but generalized to values that contain graphs
 */
export function useRetainable(config) {
    const [retained, _setRetained] = useState();
    const refRetained = useRef(retained);
    const refInitialConfig = useRef(config);
    const setRetained = useCallback((newValue) => {
        const oldValue = refRetained.current;
        if (oldValue !== undefined) {
            refInitialConfig.current.release(oldValue);
        }
        if (newValue !== undefined) {
            refInitialConfig.current.retain(newValue);
        }
        refRetained.current = newValue;
        _setRetained(refRetained.current);
    }, []);
    useEffect(() => {
        var _a, _b;
        // If provided, use the first value of createInitialValue to initialize retained
        setRetained((_b = (_a = refInitialConfig.current).createInitialValue) === null || _b === void 0 ? void 0 : _b.call(_a));
        return () => {
            // Cleanup on dismount
            setRetained(undefined);
        };
    }, [setRetained]);
    return [retained, setRetained];
}
